import { render, staticRenderFns } from "./ConsolidatedScorecardDialog.vue?vue&type=template&id=bff79f20&scoped=true"
import script from "./ConsolidatedScorecardDialog.vue?vue&type=script&lang=js"
export * from "./ConsolidatedScorecardDialog.vue?vue&type=script&lang=js"
import style0 from "./ConsolidatedScorecardDialog.vue?vue&type=style&index=0&id=bff79f20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff79f20",
  null
  
)

export default component.exports